/**
 * Detect Turnkey's OAuth *popup* return on `/auth/callback`.
 *
 * The popup and opener share `localStorage` (`oauth_state`, PKCE verifiers).
 * WalletKit's `completeRedirectOauth` always runs on mount: it consumes that
 * state, then early-returns for `flow=popup` without completing login, and
 * `clearAllOAuthData()` drops the verifier. The opener's 500ms poll then
 * throws "Missing OAuth state in storage" (swallowed as cross-origin), so
 * the popup sits on the callback spinner until hang-redirect. Mounting
 * WalletKit on this document is the hang.
 */

/** True when `href` is a Turnkey popup OAuth return to `/auth/callback`. */
export function isPopupOauthCallbackHref(href: string): boolean {
  let pathname: string;
  try {
    pathname = new URL(href).pathname;
  } catch {
    return false;
  }
  if (!/(?:^|\/)auth\/callback\/?$/.test(pathname)) return false;
  // Query `state` is URL-encoded (`flow%3Dpopup`); Google/Apple hash state is
  // often raw (`flow=popup`). Match both.
  return /(?:^|[?&#]|%26)flow(?:=|%3D)popup(?:&|%26|$|#)/i.test(href);
}
